import { j as json } from "../../../../chunks/index.js";
import { createRequire } from "module";
const require2 = createRequire(import.meta.url);
const { PrismaClient } = require2("@prisma/client");
const prisma = new PrismaClient();
const GET = async () => {
  const clients = await prisma.client.findMany();
  return json(clients);
};
const POST = async ({ request }) => {
  const { username, totalPoints, totalRounds, themePreference } = await request.json();
  const newClient = await prisma.client.create({
    data: {
      username,
      totalPoints,
      totalRounds,
      themePreference
    }
  });
  return json(newClient, { status: 201 });
};
export {
  GET,
  POST
};
